import { useTranslation } from 'react-i18next';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

export enum AnnualRevenueOptions {
  NEW_BUSINESS = 'NEW_BUSINESS',
  UNDER_10K = 'UNDER_10K',
  FROM_10K_TO_50K = 'FROM_10K_TO_50K',
  FROM_50K_TO_100K = 'FROM_50K_TO_100K',
  FROM_100K_TO_500K = 'FROM_100K_TO_500K',
  FROM_500K_TO_1M = 'FROM_500K_TO_1M',
  OVER_1M = 'OVER_1M',
}

export const AnnualRevenueForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-4'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_ANNUAL_REVENUE}>
        {({ onChange, value }) => (
          <>
            <CustomRadioButton
              label={t('organic.annualRevenue.newBusiness')}
              value={AnnualRevenueOptions.NEW_BUSINESS}
              onChange={onChange}
              checked={value === AnnualRevenueOptions.NEW_BUSINESS}
              name={EddEmbeddedFields.EDD_ANNUAL_REVENUE}
            />
            <CustomRadioButton
              label={t('organic.annualRevenue.under10k')}
              value={AnnualRevenueOptions.UNDER_10K}
              onChange={onChange}
              checked={value === AnnualRevenueOptions.UNDER_10K}
              name={EddEmbeddedFields.EDD_ANNUAL_REVENUE}
            />
            <CustomRadioButton
              label={t('organic.annualRevenue.10kTo50k')}
              value={AnnualRevenueOptions.FROM_10K_TO_50K}
              onChange={onChange}
              checked={value === AnnualRevenueOptions.FROM_10K_TO_50K}
              name={EddEmbeddedFields.EDD_ANNUAL_REVENUE}
            />
            <CustomRadioButton
              label={t('organic.annualRevenue.50kTo100k')}
              value={AnnualRevenueOptions.FROM_50K_TO_100K}
              onChange={onChange}
              checked={value === AnnualRevenueOptions.FROM_50K_TO_100K}
              name={EddEmbeddedFields.EDD_ANNUAL_REVENUE}
            />
            <CustomRadioButton
              label={t('organic.annualRevenue.100kTo500k')}
              value={AnnualRevenueOptions.FROM_100K_TO_500K}
              onChange={onChange}
              checked={value === AnnualRevenueOptions.FROM_100K_TO_500K}
              name={EddEmbeddedFields.EDD_ANNUAL_REVENUE}
            />
            <CustomRadioButton
              label={t('organic.annualRevenue.500kTo1m')}
              value={AnnualRevenueOptions.FROM_500K_TO_1M}
              onChange={onChange}
              checked={value === AnnualRevenueOptions.FROM_500K_TO_1M}
              name={EddEmbeddedFields.EDD_ANNUAL_REVENUE}
            />
            <CustomRadioButton
              label={t('organic.annualRevenue.over1m')}
              value={AnnualRevenueOptions.OVER_1M}
              onChange={onChange}
              checked={value === AnnualRevenueOptions.OVER_1M}
              name={EddEmbeddedFields.EDD_ANNUAL_REVENUE}
            />
          </>
        )}
      </ControllerWrapper>
    </div>
  );
};
